// This is a local, JSON-compatible stand-in for the future backend response.
// It intentionally contains only the step types implemented in the first slice.
const cellcombManifest = Object.freeze({
    schemaVersion: 1,
    id: 'received-request-cellcomb',
    version: 1,
    title: 'Cellcomb workflow',
    settings: {
        renderer: 'vertical-collapse',
        accordion: false,
        showStepNumbers: true,
        revealMode: 'progressive',
        nextStepOpenDelayMs: 100,
        scrollToNextStep: true,
        nextStepScrollDelayMs: 600,
        progressPersistenceMode: 'background',
    },
    steps: [
        {
            id: 'general-product-information',
            type: 'general-product-information',
            typeVersion: 1,
            order: 10,
            enabled: true,
            titleOverride: null,
            numbered: true,
            settings: {
                showMaterialMixtureCategorySelector: true,
            },
            availability: {
                visibleWhen: null,
                disabledWhen: null,
            },
            validation: {
                mode: 'component',
            },
            completion: {
                mode: 'button',
            },
            mount: {
                mode: 'eager',
            },
            navigation: {
                unavailableBehavior: 'skip',
            },
            legacy: {
                persistedStep: 1,
            },
        },
        {
            id: 'concern-elements',
            type: 'concern-substance-lists',
            typeVersion: 1,
            order: 20,
            enabled: true,
            titleOverride: null,
            numbered: true,
            settings: {
                showQuestions: true,
                showInstruction: false,
                showSubstanceListInstruction: true,
                showNoSinglePartsCheckbox: true,
                showInformationOwnerSettings: false,
                companyHasInformation: true,
                autoExpandListsMode: 'single-legislation',
                autoExpandSubstancesMode: 'single-legislation',
                autoExpandListWhenOnlyOne: true,
                includeListIdsMode: 'request-legislation-lists',
                referenceTitleMode: 'path-prefix',
            },
            availability: {
                visibleWhen: null,
                disabledWhen: null,
            },
            validation: {
                mode: 'none',
            },
            completion: {
                mode: 'button',
            },
            mount: {
                mode: 'when-reachable',
            },
            navigation: {
                unavailableBehavior: 'skip',
            },
            legacy: {
                persistedStep: 2,
            },
        },
    ],
})

export { cellcombManifest }
export default cellcombManifest
